import {Dimensions, StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  listSTyle: {gap: 10, paddingBottom: 10},
  container: {marginTop: 10, flex: 1},
  flexStyle: {flex: 1, paddingTop: Dimensions.get('screen').height / 5},
  icon: {marginRight: 10},
  buttonStyle: {
    borderRadius: 50,
  },
  refreshControl: {zIndex: 100},
  bottomDivider: {marginBottom: 20, marginHorizontal: -20, borderTopWidth: 1},
  infoBox: {
    paddingVertical: 10,
    paddingLeft: 15,
    paddingRight: 30,
    borderRadius: 10,
    marginBottom: 10,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: 10,
  },
  disclaimerText: {
    textAlign: 'left',
  },
  iconText: {
    marginTop: 5,
  },
  scanAgain: {
    textDecorationLine: 'underline',
  },
});
